export const EHS_ENDPOINT = '/api/ehs';
export const USER_SERVICE_ENDPOINT = '/api/user';
export const GVI_ENDPOINT = '/api/gvi';
